export const NOT_FOUND_CONTENT = {
  titleLine1: "죄송합니다.",
  titleLine2: "요청하신 페이지를 찾을 수 없습니다.",
  description:
    "입력하신 주소가 잘못되었거나, 삭제·변경된 페이지일 수 있습니다.\n확인 후 다시 시도해 주세요.",
  backButtonLabel: "이전 화면으로 가기",
};
